module.exports = __webpack_public_path__ + "img/undraw-file-searching.24d24649.png";